export const ACTION_TYPES = {
  LOGOUT: 'LOGOUT',
  GET_CUSTOM_TASKS_FILTERS: 'GET_CUSTOM_TASKS_FILTERS',
  SAVE_CUSTOM_TASKS_FILTER: 'SAVE_CUSTOM_TASKS_FILTER',
  DELETE_USER_FILTER_RESULTS: 'DELETE_USER_FILTER_RESULTS',
  ADD_TASK_TO_USER_FILTER_RESULTS: 'ADD_TASK_TO_USER_FILTER_RESULTS',
  SET_VISIBLE_SECTION_ID_LIST: 'SET_VISIBLE_SECTION_ID_LIST',
  CLEAR_VISIBLE_SECTION_ID_LIST: 'CLEAR_VISIBLE_SECTION_ID_LIST',
  REMOVE_FROM_VISIBLE_SECTION_ID_LIST: 'REMOVE_FROM_VISIBLE_SECTION_ID_LIST'
};
